import React from 'react';
import Breadcrumbs from '../components/Breadcrumbs';
import KeyTable from '../components/KeyTable';
import TableOfContents from '../components/TableOfContents';
import FaqSection from '../components/FaqSection';
import InternalLinksSection from '../components/InternalLinksSection';
import SourcesSection from '../components/SourcesSection';
import SeoMeta from '../components/SeoMeta';

export default function FoodArticle({ page }) {
  if (!page) return null;

  return (
    <article className="w-full min-w-0 break-words">
      <SeoMeta
        title={page.title}
        metaTitle={page.metaTitle}
        metaDescription={page.metaDescription}
        slug={page.slug}
        datePublished={page.datePublished}
        dateModified={page.dateModified}
      />

      <Breadcrumbs title={page.title} slug={page.slug} />

      <h1 className="text-3xl sm:text-4xl font-bold tracking-tight text-[#141B22] mb-4">
        {page.title}
      </h1>

      {/* Svaret som første sætning med fed kobolt */}
      <div className="text-xl sm:text-2xl font-bold text-[#2A4DB0] mb-8 leading-snug break-words">
        {page.answer}
      </div>

      {/* Kort Sådan gør du liste */}
      {page.steps && page.steps.length > 0 && (
        <div className="my-8 p-5 rounded-[6px] border border-[#DCE3EC] bg-white">
          <h2 className="text-sm font-bold uppercase tracking-wider text-[#2A4DB0] mb-3">
            Kort overblik: Sådan gør du
          </h2>
          <ol className="list-decimal pl-5 space-y-2 text-[16px] text-[#141B22]">
            {page.steps.map((step, idx) => (
              <li key={idx} className="leading-relaxed">
                {step}
              </li>
            ))}
          </ol>
        </div>
      )}

      {/* Indholdsfortegnelse på lange sider */}
      {page.sections && page.sections.length > 1 && (
        <TableOfContents sections={page.sections} />
      )}

      {/* Nøgletabel: Holdbarhed på frost · Pakning · Optøning · Brug efter optøning */}
      <KeyTable data={page.table} note={page.tableNote} />

      {/* Dybdegående sektioner under h2'er */}
      {page.sections && page.sections.map((section, idx) => (
        <section key={idx} id={`sektion-${idx + 1}`} className="my-10 pt-4 border-t border-[#DCE3EC] first:border-t-0">
          <h2 className="text-2xl font-bold text-[#141B22] mb-4">
            {section.h2}
          </h2>
          <div className="text-[17px] text-[#141B22] leading-relaxed whitespace-pre-line space-y-4">
            {section.body}
          </div>
        </section>
      ))}

      {/* FAQ sektion med 3-5 spørgsmål og JSON-LD */}
      <FaqSection faq={page.faq} />

      {/* Interne links */}
      <InternalLinksSection links={page.internalLinks} />

      {/* Kilder */}
      <SourcesSection sources={page.sources} />
    </article>
  );
}
